import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { accentPair } from "@/lib/contrast";

export const field = "min-h-[44px] w-full border border-ink bg-white px-3 text-[16px] text-ink outline-none focus-visible:outline-2 focus-visible:outline-ink";
export const label = "block text-[14px] font-semibold text-ink";

/**
 * Every signup screen (7.12): "Step n of 7" + a progress bar in the accent color, one Back link,
 * the question, and ONE primary button. No header menu, no footer, nothing else to click.
 */
export default function SignupShell({ step, total = 7, title, lead, children, primary, onPrimary, busy, disabled,
    back, error, onRetry, accent }) {
    const pct = Math.round((step / total) * 100);
    const pair = accentPair(accent || "#1a1a1a");
    return (
        <div className="min-h-[100dvh] bg-white text-ink" data-testid="signup-shell" style={{ "--signup-accent": pair.accent, "--signup-on": pair.on }}>
            <div className="mx-auto flex min-h-[100dvh] w-full max-w-[560px] flex-col px-3 py-4 sm:px-6">
                <div className="flex items-center justify-between text-[14px]">
                    {back ? (
                        typeof back === "string"
                            ? <Link to={back} className="flex min-h-[44px] items-center underline" data-testid="signup-back">Back</Link>
                            : <button type="button" onClick={back} className="flex min-h-[44px] items-center underline" data-testid="signup-back">Back</button>
                    ) : <span />}
                    <span className="font-semibold" data-testid="signup-step">Step {step} of {total}</span>
                </div>
                <div className="mt-1 h-2 w-full border border-ink" data-testid="signup-progress" role="progressbar" aria-valuenow={step} aria-valuemin={1} aria-valuemax={total}>
                    <div className="h-full" style={{ width: `${pct}%`, background: "var(--signup-accent)" }} />
                </div>

                <h1 className="mt-7 text-[28px] font-semibold leading-tight sm:text-[32px]" data-testid="signup-title">{title}</h1>
                {lead && <p className="mt-2 text-[16px] text-muted-ink" data-testid="signup-lead">{lead}</p>}

                <div className="mt-6 flex-1">{children}</div>

                {error && (
                    <div className="mt-4 border border-[#b3261e] px-3 py-2 text-[15px] text-[#b3261e]" data-testid="signup-error" role="alert">
                        {error}
                        {onRetry && <button type="button" onClick={onRetry} className="ml-3 underline" data-testid="signup-retry">Try again</button>}
                    </div>
                )}

                {primary && (
                    <button type="button" onClick={onPrimary} disabled={busy || disabled} data-testid="signup-next"
                        className="mt-6 flex min-h-[52px] w-full items-center justify-center gap-2 border border-ink px-4 text-[17px] font-semibold disabled:opacity-50"
                        style={{ background: "var(--signup-accent)", color: "var(--signup-on)" }}>
                        {busy && <Loader2 size={16} className="animate-spin" />} {primary}
                    </button>
                )}
            </div>
        </div>
    );
}
